import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { UNSUBSCRIBE_API_PREFIX } from '../api/unsubscribe-api'

// TODO: move to tanstack
export const useUnsubscribe = (): {
  unsubscribeFromAllMarketingEmails: (slug: string, messageId: string) => Promise<void>
  unsubscribeFromCampaign: (slug: string, messageId: string, campaignId: string) => Promise<void>
  unsubscribeFromAutomationRule: (recipientEmailAddress: string, id: string) => Promise<void>
  unsubscribeFromTransactionalEmail: (slug: string) => Promise<void>
  isFetching: boolean
} => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.delete,
  })
  return {
    unsubscribeFromAllMarketingEmails: async (slug: string, messageId: string) => {
      await fetcher(`${UNSUBSCRIBE_API_PREFIX}/marketing-emails/${slug}/${messageId}/all`)
    },

    unsubscribeFromCampaign: async (slug: string, messageId: string, campaignId: string) => {
      await fetcher(
        `${UNSUBSCRIBE_API_PREFIX}/marketing-emails/${slug}/${messageId}/campaign/${campaignId}`,
      )
    },

    unsubscribeFromAutomationRule: async (recipientEmailAddress: string, id: string) => {
      await fetcher(`${UNSUBSCRIBE_API_PREFIX}/automation-rule/${recipientEmailAddress}/${id}`)
    },

    unsubscribeFromTransactionalEmail: async (slug: string) => {
      await fetcher(`${UNSUBSCRIBE_API_PREFIX}/transactional-emails/${slug}`)
    },

    isFetching: isFetching,
  }
}
